export default class Reference {
	packageSize: number | null;

	referenceBasketVersion: string;

	historicProductDataViewDate: Date | null;

	constructor(packageSize: number | null, referenceBasketVersion: string, historicProductDataViewDate: Date | null) {
		this.packageSize = packageSize;
		this.referenceBasketVersion = referenceBasketVersion;
		this.historicProductDataViewDate = historicProductDataViewDate;
	}
}
